import React from 'react'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import { format, isSameDay, parseISO } from 'date-fns'

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    width: '100%',
    textAlign: 'center',
    height: 'min-content',
    marginBottom: theme.spacing(1),
  },
}))

export const MobileTableDivider = <T,>({
  itemList,
  index,
  labelPrefix,
  children,
  dateKey = 'createdAt' as keyof T,
}: {
  itemList: T[]
  index: number
  labelPrefix?: string
  children: React.ReactElement
  dateKey?: keyof T
}) => {
  const classes = useStyles()

  if (!itemList || index + 1 === itemList.length || itemList.length <= 2) return <>{children}</>

  const prevItem = itemList[index - 1]
  const currentItem = itemList[index]

  const prevDate = prevItem?.[dateKey]
  const currentDate = currentItem?.[dateKey]

  const isShowDivider =
    (prevDate && !currentDate) ||
    (currentDate && !prevDate) ||
    (typeof currentDate === 'string' &&
      typeof prevDate === 'string' &&
      !isSameDay(new Date(currentDate), new Date(prevDate)))

  const dividerText = currentDate
    ? [labelPrefix, format(parseISO(currentDate as string), 'dd.MM.yyyy')]
        .filter((item) => item)
        .join(' ')
    : ''

  return (
    <>
      {isShowDivider && (
        <Typography variant="subtitle2" color="textSecondary" className={classes.divider}>
          {dividerText}:
        </Typography>
      )}
      {children}
    </>
  )
}
